import { Component, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/sharing-data.service';
import { LandingPageService } from './landing-page/landing-page.service';
import { AuthService } from '../AuthService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
 
  title = 'angular-Franky';
  public screenWidth: any;
  public screenHeight: any;
    // saved scroll position when locking body for sidebar
    private _savedBodyScrollY: number | null = null;
    private _originalBodyPaddingRight: string | null = null;
  
    ngOnInit(): void {
      // Your initialization logic here
      console.log('Component initialized!');
      this.viewAllFourProducts();
      this.showAboutComponent = false;
      this.menplain=false;
      this.menPrinted=false;
      this.womenplain=false;
      this.womenPrinted=false;
      this.Cart=0;
      this.viewProductComponent = false;
      this.viewCartPage = false;
   this.getScreenSize();
      this.shippingPolicy=false;
      this.returnExchange=false;
      this.termsOfService=false;
      this.privacyPolicy=false;
      this.isOpen=false;
      this.isOpenLogin=false;
      
    // wire mobile dropdowns after DOM is ready
    setTimeout(() => this.enableMobileDropdowns(), 50);
    // ensure body padding matches header height on init (for mobile/tablet)
    setTimeout(() => this.adjustBodyPaddingForHeader(), 70);
    
    }
     @HostListener('window:resize')
    onResize() {
      this.screenWidthh = window.innerWidth;
      this.updateVisibleImages();
      // recompute header padding on resize
      this.adjustBodyPaddingForHeader();
    }
    @HostListener('window:resize', ['$event'])
  getScreenSize() {
  this.screenWidth = window.innerWidth;
  this.screenHeight = window.innerHeight;
  console.log(this.screenWidth, this.screenHeight);
  this.updateVisibleImages();
   // recompute header padding when screen size queried
   this.adjustBodyPaddingForHeader();
  }
  
   screenWidthh = window.innerWidth;
    showAboutComponent = false;
    menplain=false;
    menPrinted=false;
    Cart=0;
    viewProductComponent = false;
    viewCartPage = false;
    product="Hii";
    products:any;
    searchQuery: string = '';
    shippingPolicy=false;
    returnExchange=false;
    termsOfService=false;
    privacyPolicy=false;
    isOpen=false;
    womenplain=false;
  womenPrinted=false;
  ordersPage=false;
  accountPage=false;
  isOpenLogin=false;
  newArrivals=false;
  bestSellers=false;
     visibleImages: any[] = [];
    touchStartProductX: any;
    touchStartProductY: any;
    currentProduct: any;
  currentIndex = 0;
  notCart=false;
    isSearchOpen: boolean = false;
    private outsideClickListener: ((evt: Event) => void) | null = null;
    private sidebarOutsideListener: ((evt: Event) => void) | null = null;
    private dropdownClickListeners: Array<() => void> = [];
    constructor(private router: Router,private sharingData: SharingDataService,private landingService : LandingPageService,private authService : AuthService) {
    // Navigate to home on page load/refresh
    this.router.navigate(['/home']);
     this.Cart=0;
    this.getScreenSize();
  }
    toggleSearch(event?: Event) {
      // Toggle the search input
      if (this.isSearchOpen) {
        // close
        this.isSearchOpen = false;
        this.removeOutsideListener();
        if (event) event.stopPropagation();
        return;
      }
      // open
      this.isSearchOpen = true;
      // focus input when opening
      setTimeout(() => {
        const el = document.getElementById('headerSearchInput') as HTMLInputElement | null;
        if (el) el.focus();
      }, 0);
      // stop the click from bubbling to document
      if (event) {
        event.stopPropagation();
      }
      // add outside click listener to close when clicking elsewhere
      this.addOutsideListener();
    }
  
    private addOutsideListener() {
      if (this.outsideClickListener) return;
      this.outsideClickListener = (evt: Event) => {
        this.isSearchOpen = false;
        this.removeOutsideListener();
      };
      document.addEventListener('click', this.outsideClickListener);
    }
  
    private removeOutsideListener() {
      if (!this.outsideClickListener) return;
      document.removeEventListener('click', this.outsideClickListener);
      this.outsideClickListener = null;
    }
  
    private addSidebarOutsideListener() {
      if (this.sidebarOutsideListener) return;
      this.sidebarOutsideListener = (evt: Event) => {
        // if click is outside sidebar, close it
        const sidebarEl = document.querySelector('.sidebar');
        if (sidebarEl && !sidebarEl.contains(evt.target as Node)) {
          this.isOpen = false;
          this.removeSidebarOutsideListener();
        }
      };
      document.addEventListener('click', this.sidebarOutsideListener);
    }
  
    private removeSidebarOutsideListener() {
      if (!this.sidebarOutsideListener) return;
      document.removeEventListener('click', this.sidebarOutsideListener);
      this.sidebarOutsideListener = null;
      try {
        document.body.classList.remove('has-open-sidebar');
      } catch (e) {
        // ignore
      }
    }
  
    toggleSidebar() {
      this.isOpenLogin = !this.isOpenLogin;
       this.notCart=true;
      if (this.isOpenLogin) {
        document.body.style.overflow = 'hidden';
        this.addSidebarOutsideListener();
      } else {
        document.body.style.overflow = '';
        this.removeSidebarOutsideListener();
      }
      // sidebar open/close can change header layout; update padding
      setTimeout(() => this.adjustBodyPaddingForHeader(), 20);
    }
  
    loginButton() {
      this.toggleSidebar(); // Reuse the toggle sidebar logic for consistent behavior
    }
  
    menOversizedPlain() {
      console.log(" menOversizedPlain button clicked");
      this.menplain = true;
      this.router.navigate(['/menplain']);
    }
    login=false;
  
      loginButtonFn() {
      console.log(" loginButtonFn button clicked");
      this.login = true;
      this.notCart=true;
      this.toggleSidebar();
     // this.router.navigate(['/menplain']);
    }
  
    menOversizedPrinted(){
      console.log(" menOversizedPrinted button clicked");
      this.menPrinted = true;
      this.router.navigate(['/menprinted']);
    }
  
    womenOversizedPlain() {
      console.log(" womenOversizedPlain button clicked");
      this.womenplain = true;
      this.router.navigate(['/womenplain']);
    }
  
     bestSellersFn(){
      console.log(" bestSellersFn button clicked");
      this.bestSellers = true;
      this.router.navigate(['/bestSellers']);
    }
  
     newArrivalsFn(){
      console.log(" newArrivalsFn button clicked");
      this.newArrivals = true;
      this.router.navigate(['/newArrivals']);
    }
  
     ordersPageFn() {
      console.log(" Orders button clicked");
      this.ordersPage = true;
      this.router.navigate(['/order']);
      this.toggleSidebar();
    }
  
     accountPageFn() {
      console.log(" Accounts button clicked");
      this.accountPage = true;
      this.router.navigate(['/account']);
      this.toggleSidebar();
    }
  
    womenOversizedPrinted(){
      console.log(" womenOversizedPrinted button clicked");
      this.womenPrinted = true;
      this.router.navigate(['/womenprinted']);
    }
  
    viewProduct(product:Object) {
      console.log(" menOversizedPlain button clicked");
      this.viewProductComponent = true;
      this.router.navigate(['/viewProducts']);
      this.sharingData.updateValue(product);
      console.log('clicked view product: ',product);
    }
  
    
    viewCartButton() {
      this.notCart=false;
      console.log(" viewCartButton button clicked");
      this.viewCartPage = true;
      this.sharingData.updateValue(this.product);
      console.log('sender:: ',this.product)
      this.router.navigate(['/viewCart']);
      this.toggleSidebar();
      
    }
  
    // Banner image paths are now defined in CSS using data-banner attributes
    // This array is kept for carousel logic (to determine banner count)
    private readonly BANNER_COUNT = 5;
    currentBanner = 0;
    currentProducts = 0;
  
    @ViewChild('mobileMenu') dropdownRef!: ElementRef;
  
    toggleDropdown(event?: Event): void {
      event?.stopPropagation(); // Prevent event from bubbling up
      this.isOpen = !this.isOpen;
      
      // Lock body scroll when menu is open
      if (this.isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }  @HostListener('document:click', ['$event'])
    handleClickOutside(event: MouseEvent): void {
      // If the dropdown reference isn't available yet, or if we clicked a toggle button, do nothing
      if (!this.dropdownRef?.nativeElement || 
          (event.target as HTMLElement).closest('.navbar-toggler')) {
        return;
      }
      
      // Check if click was outside the dropdown
      const clickedInside = this.dropdownRef.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.isOpen = false;
      }
    }
    // touch swipe tracking for banners
    private touchStartX: number | null = null;
    private touchEndX: number | null = null;
  
    private touchEndProductX: number | null = null;
    private readonly SWIPE_THRESHOLD = 50; // px
    nextBanner() {
      this.currentBanner = (this.currentBanner + 1) % this.BANNER_COUNT;
    }
  
    prevBanner() {
      this.currentBanner = (this.currentBanner - 1 + this.BANNER_COUNT) % this.BANNER_COUNT;
    }
  
    // Touch handlers for mobile swipe
    onTouchStart(evt: TouchEvent) {
      if (!evt.touches || evt.touches.length === 0) return;
      this.touchStartX = evt.touches[0].clientX;
      this.touchEndX = null;
    }
  
    onTouchMove(evt: TouchEvent) {
      if (!evt.touches || evt.touches.length === 0) return;
      this.touchEndX = evt.touches[0].clientX;
    }
  
    onTouchEnd() {
      if (this.touchStartX === null || this.touchEndX === null) return;
      const delta = this.touchStartX - this.touchEndX;
      if (Math.abs(delta) < this.SWIPE_THRESHOLD) {
        // not a meaningful swipe
        this.touchStartX = null;
        this.touchEndX = null;
        return;
      }
      if (delta > 0) {
        // swiped left -> next banner
        this.nextBanner();
      } else {
        // swiped right -> prev banner
        this.prevBanner();
      }
      this.touchStartX = null;
      this.touchEndX = null;
    }
  
  
  
   getVisibleCount(): number {
     console.log('Screen width is ',this.screenWidth);
      if (this.screenWidth <= 500) return 1;
      if (this.screenWidth <= 768) return 2;
     
      return 4;
    }
  updateVisibleImages() {
     if (!this.products || this.products.length === 0) {
      this.visibleImages = [];
      return;
    }
    const count = this.getVisibleCount();
    console.log('count=',count);
    this.visibleImages = this.products.slice(this.currentIndex, this.currentIndex + count);
  }
  
  nextBannerProducts() {
    const count = this.getVisibleCount();
     this.currentIndex = (this.currentIndex + count) % this.products.length;
      this.updateVisibleImages();
  }
  
  prevBannerProducts() {
  const count = this.getVisibleCount();
      this.currentIndex = (this.currentIndex - count + this.products.length) % this.products.length;
      this.updateVisibleImages();
  }
  
    ngOnDestroy(): void {
    this.removeOutsideListener();
    this.removeSidebarOutsideListener();
      this.removeDropdownListeners();
      // clear any padding we applied
      try { document.body.style.paddingTop = ''; } catch (e) { }
    }
  
    /**
     * Measure the header element's height and set body padding-top for
     * small screens where header is fixed. This avoids the banner being
     * hidden behind the fixed header. No-op on large screens.
     */
    adjustBodyPaddingForHeader() {
      try {
        const header = document.querySelector('.headerClass') as HTMLElement | null;
        if (!header) return;
        const height = header.offsetHeight || 0;
        // Apply padding equal to header height so content starts below it.
        // Header is fixed for all sizes now, so set padding unconditionally.
        document.body.style.paddingTop = height + 'px';
      } catch (e) {
        // ignore errors (defensive)
      }
    }
  
    // Mobile: enable tapping a .nav-item.dropdown to toggle its submenu
    enableMobileDropdowns() {
      // only on small screens
      if (window.innerWidth > 768) return;
      const dropdowns = Array.from(document.querySelectorAll('.menuDropdownList .nav-item.dropdown')) as HTMLElement[];
      dropdowns.forEach((d) => {
        const handler = (e: Event) => {
          e.stopPropagation();
          // toggle .show on the dropdown
          d.classList.toggle('show');
        };
        d.addEventListener('click', handler);
        this.dropdownClickListeners.push(() => d.removeEventListener('click', handler));
      });
    }
  
    removeDropdownListeners() {
      this.dropdownClickListeners.forEach((remove) => remove());
      this.dropdownClickListeners = [];
    }
  
    performSearch() {
      const q = (this.searchQuery || '').trim().toLowerCase();
      if (!q) {
        // If empty, restore default view
        this.updateVisibleImages();
        return;
      }
      // If products are not yet loaded, fetch them first then apply filter
      if (!this.products || !Array.isArray(this.products) || this.products.length === 0) {
        this.landingService.ViewAllProductsFunctions().subscribe({
          next: (response: any) => {
            this.products = response || [];
            this.applyFilter(q);
          },
          error: (err: any) => {
            console.error('Error fetching products for search:', err);
          }
        });
        return;
      }
      this.applyFilter(q);
    }
  
    private applyFilter(q: string) {
      const filtered = this.products.filter((p: any) => {
        const name = (p.productName || '') + '';
        const desc = (p.productDescription || '') + '';
        return name.toLowerCase().includes(q) || desc.toLowerCase().includes(q);
      });
      // show first 4 matching results
      this.visibleImages = filtered.slice(0, 4);
      this.currentIndex = 0;
    }
  
    clearSearch() {
      this.searchQuery = '';
      this.updateVisibleImages();
    }
   
   viewAllFourProducts(){
    this.landingService.ViewAllProductsFunctions().subscribe({
      next:(response) => {
        console.log('All products are', response);
        this.products=response;
        console.log('All products are', this.products);
          this.updateVisibleImages();
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  }
  
  
  
  shippingPolicyFn(){
  this.shippingPolicy=true;
  this.router.navigate(['/shoppingPoilcy']);
  }
  returnExchangeFn(){
    this.returnExchange=true;
    this.router.navigate(['/returnAndRefundPolicy']);
    }
    privacyPolicyFn(){
      this.privacyPolicy=true;
      this.router.navigate(['/privacyPolicy']);
      }
        
      termsOfServiceFn(){
        this.termsOfService=true;
        this.router.navigate(['/termsOfService']);
        }
  
        logoutAuthFn(){
          
    this.authService.logout();
    this.router.navigate(['#']);
   alert('Logged out successfully');
    this.toggleSidebar();
  }
  
  handleTouchStart(event: TouchEvent, product: any) {
    // Store the initial touch coordinates
    this.touchStartProductX = event.changedTouches[0].clientX;
    this.touchStartProductY = event.changedTouches[0].clientY;
    this.currentProduct = product;
  }
  
  handleTouchMove(event: TouchEvent, product: any) {
    // Prevent scrolling on the page
    event.preventDefault();
    
    // Calculate the distance and direction of the swipe
    const touchMoveX = event.changedTouches[0].clientX;
    const touchMoveY = event.changedTouches[0].clientY;
    const deltaX = this.touchStartProductX - touchMoveX;
    const deltaY = this.touchStartProductY - touchMoveY;
    
    // Check if the swipe is horizontal
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      // Swipe left
      if (deltaX < 0) {
        this.prevBannerProducts();
      }
      // Swipe right
      else if (deltaX > 0) {
        this.nextBannerProducts();
      }
    }
  }
  
  handleTouchEnd(event: TouchEvent, product: any) {
    // Reset the touch coordinates
    this.touchStartProductX = null;
    this.touchStartProductY = null;
    this.currentProduct = null;
  }
  
  swipeLeft(product: any) {
    // Perform the desired action for left swipe
    console.log('Swiped left on product:', product);
    // You can navigate to the previous product or perform any other action here
  }
  
  swipeRight(product: any) {
    // Perform the desired action for right swipe
    console.log('Swiped right on product:', product);
    // You can navigate to the next product or perform any other action here
  }
  
  }


